import {
  DOWNLOAD_LEGAL_DOCUMENT_FAILED,
  DOWNLOAD_LEGAL_DOCUMENT_REQUEST,
  DOWNLOAD_LEGAL_DOCUMENT_SUCCESS,
  RESET_SETTINGS,
  SAVE_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_FAILED,
  SAVE_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_REQUEST,
  SAVE_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_SUCCESS,
  SET_AUDIO_START_TIME,
  SET_AUTO_SCROLL_WITH_SYNC,
  SET_FONT_SIZE,
  SET_OPEN_SPEAKER_MODAL,
  SET_REWIND_TIME,
  SET_SYNC_WITH_AUDIO,
  UPDATE_LAST_WORKED_PARAGRAPH,
  UPLOAD_LEGAL_DOCUMENT_FAILED,
  UPLOAD_LEGAL_DOCUMENT_REQUEST,
  UPLOAD_LEGAL_DOCUMENT_SUCCESS,
} from '../../../../constants/ActionNameConstants';

export const setRewindTime = (rewindTime) => ({
  type: SET_REWIND_TIME,
  payload: rewindTime,
});

export const setFontSize = (fontSize) => ({
  type: SET_FONT_SIZE,
  payload: fontSize,
});

export const setOpenSpeakerModal = (modalId) => ({
  type: SET_OPEN_SPEAKER_MODAL,
  payload: modalId,
});

export const resetSettings = () => ({
  type: RESET_SETTINGS,
});

export const setSyncWithAudio = (syncWithAudio) => ({
  type: SET_SYNC_WITH_AUDIO,
  payload: syncWithAudio,
});

export const setAutoScrollWithSync = (autoScroll) => ({
  type: SET_AUTO_SCROLL_WITH_SYNC,
  payload: autoScroll,
});

export const setAudioStartTime = (time) => ({
  type: SET_AUDIO_START_TIME,
  payload: time,
});

export const updateLastWorkedParagraph = (paragraph) => ({
  type: UPDATE_LAST_WORKED_PARAGRAPH,
  payload: paragraph,
});

export const saveOrUpdateTemplateFormDetailsRequest = (data) => ({
  type: SAVE_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_REQUEST,
  payload: data,
});

export const saveOrUpdateTemplateFormDetailsSuccess = (response) => ({
  type: SAVE_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_SUCCESS,
  payload: response,
});

export const saveOrUpdateTemplateFormDetailsFailure = (error) => ({
  type: SAVE_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_FAILED,
  payload: error,
});

export const downloadLegalDocumentRequest = (data) => ({
  type: DOWNLOAD_LEGAL_DOCUMENT_REQUEST,
  payload: data,
});

export const downloadLegalDocumentSuccess = (response) => ({
  type: DOWNLOAD_LEGAL_DOCUMENT_SUCCESS,
  payload: response,
});

export const downloadLegalDocumentFailure = (error) => ({
  type: DOWNLOAD_LEGAL_DOCUMENT_FAILED,
  payload: error,
});

export const uploadLegalDocumentRequest = (data) => ({
  type: UPLOAD_LEGAL_DOCUMENT_REQUEST,
  payload: data,
});

export const uploadLegalDocumentSuccess = (response) => ({
  type: UPLOAD_LEGAL_DOCUMENT_SUCCESS,
  payload: response,
});

export const uploadLegalDocumentFailure = (error) => ({
  type: UPLOAD_LEGAL_DOCUMENT_FAILED,
  payload: error,
});
